import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import SuccessMessage from '../common/SuccessMessage'
import ErrorMessage from '../common/ErrorMessage'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import constant from '../../constant'

export default function AddCompanyType(props) {

    const { id } = useParams()

    const [error, setError] = useState(false)
    const Navigate = useNavigate()
    const [data, setData] = useState({
        COMPANY_TYPE: '',
        COMPANY_TYPE_DETAILS: '',
        SORT_NUMBER: ''
    })
    const detail = props.detail;

    const handleChange = (e) => {
        const { name, value } = e.target
        setData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const onSubmit = () => {
        if (data.COMPANY_TYPE.trim().length === 0 || data.SORT_NUMBER.toString().trim().length === 0) {
            setError(true)
            return false
        }
        const model = {
            COMPANY_TYPE: data.COMPANY_TYPE,
            COMPANY_TYPE_DETAILS: data.COMPANY_TYPE_DETAILS,
            SORT_NUMBER: data.SORT_NUMBER,
        }
        if (detail) {
            model.COMPANY_TYPE_ID = detail.COMPANY_TYPE_ID
        }
        props.onSubmit(model)
    }

    const handleReset = (e) => {
        e.preventDefault();
        id && Navigate(constant.component.companytypelist.url)
        setError(false)
        setData({
            COMPANY_TYPE: '',
            COMPANY_TYPE_DETAILS: '',
            SORT_NUMBER: ''
        })

    }

    useEffect(() => {
        if (detail) {
            setData({
                COMPANY_TYPE: detail.COMPANY_TYPE,
                COMPANY_TYPE_DETAILS: detail.COMPANY_TYPE_DETAILS,
                SORT_NUMBER: detail.SORT_NUMBER
            })
        }



    }, [])
    return (
        <React.Fragment>
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 className="mb-sm-0 font-size-18">{detail ? "Update Company Type" : "Add Company Type"}</h4>

                                    <div className="page-title-right">
                                        <ol className="breadcrumb m-0">
                                            <li className="breadcrumb-item"><a href="javascript: void(0);">Employers</a></li>
                                            <li className="breadcrumb-item active">{detail ? "Update Company Type" : "Add Company Type"}</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title mb-4">Company Type Information</h4>
                                        {
                                            props.showMsg && (props.response.status ?
                                                <SuccessMessage message={props.response.messageCode} />
                                                :
                                                <ErrorMessage message={props.response.error} />)
                                        }
                                        <div id="basic-example">
                                            <section>
                                                <form method="POST">
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <label for="basicpill-firstname-input">Company Type <span className='text-danger'>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className={error && data.COMPANY_TYPE.trim().length === 0 ? 'form-control is-invalid ' : 'form-control'}
                                                                    id="basicpill-firstname-input"
                                                                    placeholder="Enter Company Type"
                                                                    onChange={handleChange}
                                                                    name='COMPANY_TYPE'
                                                                    value={data.COMPANY_TYPE} />
                                                                {error && data.COMPANY_TYPE.trim().length === 0 ? <span className='text-danger ml-1'> This Field is Required</span> : ''}
                                                            </div>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <label for="basicpill-address-input">Sort Number <span className='text-danger'>*</span></label>
                                                                <NumberFormat
                                                                    type="text"
                                                                    className={error && data.SORT_NUMBER.toString().trim().length <= 0 ? 'form-control is-invalid ' : 'form-control'}
                                                                    id="basicpill-firstname-input"
                                                                    placeholder="Enter Sort Number"
                                                                    onChange={handleChange}
                                                                    name='SORT_NUMBER'
                                                                    value={data.SORT_NUMBER}
                                                                />
                                                                {error && data.SORT_NUMBER.toString().trim().length <= 0 ? <span className='text-danger ml-1'> This Field is Required</span> : ''}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">

                                                        <div className="col-lg-12">
                                                            <div className="mb-3">
                                                                <label for="basicpill-address-input">Company Type Details</label>
                                                                <textarea
                                                                    id="basicpill-address-input"
                                                                    className="form-control"
                                                                    rows="2"
                                                                    placeholder="Enter Company Type Details"
                                                                    onChange={handleChange}
                                                                    name='COMPANY_TYPE_DETAILS'
                                                                    value={data.COMPANY_TYPE_DETAILS}
                                                                ></textarea>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col-lg-6">
                                                            <div className="mb-3">
                                                                <button type="button" onClick={() => onSubmit()} className="btn btn-info waves-effect btn-label waves-light"><i className="bx bx-check-double label-icon"></i> {detail ? 'Save Changes' : 'Create Company Type'}</button>&nbsp;&nbsp;
                                                                <button type="button" onClick={handleReset} className="btn btn-danger waves-effect btn-label waves-light"><i className="bx bx-block label-icon "></i> Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </section>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
